import React, {useContext} from "react";
import {DimensionsContext} from "@common/utils/mobileUtils";
import {View} from "react-native";
import PricingColumnM from "./PricingColumnM";

export const PricingTableM = (props) => {
    const {withCommitment, pricingTableData, pricingTableDataNextMode, userEmail, startNextMonth = false, onPress = null, subscribedProductPriceId, forceBigSize = false} = props
    const dimensions = useContext(DimensionsContext)

    return <View style={{
        flexDirection: forceBigSize ? "column" : dimensions?.width < 800 ? "column" : "row",
        alignItems: forceBigSize ? "center" : (dimensions?.width < 800 ? "center" : "stretch"),
        flex: 1,
        marginTop: 60,
        paddingHorizontal: 100,
        // backgroundColor: "black",
    }}>
        {pricingTableData?.map((pricingColumn, index) => {
            return <PricingColumnM withCommitment={withCommitment}
                                   userEmail={userEmail}
                                   data={pricingColumn}
                                   onPress={onPress}
                                   nextModeData={pricingTableDataNextMode?.[0]}
                                   index={index}
                                   startNextMonth={startNextMonth}
                                   key={index}
                                   selected={subscribedProductPriceId === pricingColumn?.prices?.monthly?.stripe_id}
                                   forceBigSize={forceBigSize}/>
        })}
    </View>;
}